export const API_URL = 'https://api.eleave.in/';
// export const API_URL = 'http://localhost:8888/Vidupu/Vidupu-API/';
